import { Model, NeoModel, Rules, Validation } from '@singularsystems/neo-core';
import { InvestmentType } from "./Investment.enum";

@NeoModel
export default class UnauthorisedInvestmentCriteria extends Model.CriteriaBase {

    @Rules.Required()
    public investmentType: InvestmentType | null = null;

    // Client only properties / methods

    protected static addBusinessRules(rules: Validation.Rules<UnauthorisedInvestmentCriteria>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Unauthorised Investment Criteria";
    }
}